"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TableRow = void 0;
var PropTypes = require("prop-types");
var React = require("react");
var TableColumn_1 = require("./TableColumn");
var TableRow = function (_a) {
    var children = _a.children, isHeader = _a.isHeader, isSelected = _a.isSelected, columnsAlignments = _a.columnsAlignments;
    var alignmentProp = 'alignment';
    var childrenArray = Array.isArray(children) ? children : [children];
    return (React.createElement("tr", null, React.Children.map(childrenArray, function (child, index) { var _a; return React.cloneElement(child, { isHeader: isHeader, isSelected: isSelected, alignment: (_a = child.props[alignmentProp]) !== null && _a !== void 0 ? _a : columnsAlignments[index] }); })));
};
exports.TableRow = TableRow;
exports.TableRow.defaultProps = {
    isHeader: false,
    isSelected: false,
};
exports.TableRow.propTypes = {
    columnsAlignments: PropTypes.arrayOf(PropTypes.oneOf(Object.values(TableColumn_1.Alignment)).isRequired),
    isHeader: PropTypes.bool,
    isSelected: PropTypes.bool,
};
